<template>
  <div v-if="price.currency">
    <span v-if="price.type === priceType.POA">{{ $t('listing.poa') }}</span>

    <Currency
      v-if="price.type === priceType.FIXED || !price.type"
      :value="compPrice.price"
      :format="{ key: 'currency', currency: price.currency }"
    />

    <span v-if="price.type === priceType.RANGE">
      <Currency :value="compPrice.min" :format="{ key: 'currency', currency: price.currency }" />
      <span>{{ ` - ` }}</span>
      <Currency :value="compPrice.max" :format="{ key: 'currency', currency: price.currency }" />
    </span>

    <span v-if="price.type !== priceType.POA" :class="unitClass">
      {{ shortUnit ? unitHumanReadablePerUnits['short'][price.unit] : unitHumanReadablePerUnits[price.unit] }}
    </span>
  </div>
</template>

<script>
import { priceType } from '@/lib/mapping'
import { unitHumanReadablePerUnits } from '@/lib/mapping/unit'

export default {
  name: 'UtilPrice',
  props: {
    price: {
      type: Object,
      required: true
    },
    unitClass: {
      type: String,
      default: 'text-base font-normal'
    },
    shortUnit: Boolean
  },
  data() {
    return {
      unitHumanReadablePerUnits,
      priceType
    }
  },
  computed: {
    compPrice() {
      return {
        price: Number(this.price.price),
        min: Number(this.price.min),
        max: Number(this.price.max)
      }
    }
  }
}
</script>
